import api from "../../services/api";

export const getProjects = async(id, setProjects, setLoadingProjects) => {
    const idToken = localStorage.getItem("idToken");
    setLoadingProjects(true);
    try {
        const projects = await api.getProjects(id, idToken);
        setProjects(projects);
    } catch (error) {
        console.error("error", error);
    };
    setLoadingProjects(false);
};

export const getDestinationsBySelectedProject = async(projectId, setDestinations, setLoadingDestinations) => {
    const idToken = localStorage.getItem("idToken");
    setLoadingDestinations(true);
    try {
        const destinationsResponse = await api.getDestinations(projectId, idToken);
        const destinations = destinationsResponse.data;
        setDestinations(destinations);
    } catch (error) {
        console.error("error", error);
    };
    setLoadingDestinations(false);
};